import { render, staticRenderFns } from "./MobileUserAndPayment.vue?vue&type=template&id=01e5123a&"
import script from "./MobileUserAndPayment.vue?vue&type=script&lang=js&"
export * from "./MobileUserAndPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports